import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lead-boost-indicator',
  templateUrl: './lead-boost-indicator.component.html',
  styleUrls: ['./lead-boost-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadBoostIndicatorComponent {
  @Input() progress = 0;
  @Input() duration = 0;
  @Input() mini: boolean;
}
